import '../App.css';
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import main_Logo from '../assets/images/logo.png';
import Logo from '../assets/images/brainium.png';
import background from "../assets/images/banner-bg.jpeg";
import Logo3 from '../assets/images/leadorchard.png';
import Logo4 from '../assets/images/rishabh.png';
import Logo5 from '../assets/images/technolabs.png';
import Logo6 from '../assets/images/tinkerly.png';
import { useNavigate } from 'react-router-dom';
import { userDetails } from './slice';
import { useDispatch, useSelector } from 'react-redux';
import { useMemo } from 'react';
import { postFormData } from '../sevice/Service';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import Select from 'react-select';
import countries from 'countries-list';

function HireTalent5() {
  const [role, setRole] = useState({});
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const details_data = useSelector((state) => state.reducerApp.details)
  const complete_data = useSelector((state) => state.reducerApp)
  const [submitted, setSubmitted] = useState(false)
  const [fnameValid, setFnameValid] = useState(null)
  const [lnameValid, setLnameValid] = useState(null)
  const [emailValid, setEmailValid] = useState(null)
  const [numberValid, setNumberValid] = useState(null)
  const [emailError,setEmailError] = useState('')
  const [isLoading, setIsLoading] = useState(false);
  const [parameters, setParameters] = useState({
    client_requirement: {
      data: {
        hiring_roles: [],
        company_strength: [],
        project_type: [],
        contract_duration: [],
      }
    }
    }
  );

  const payload = useMemo(() => {
    const params = {
      attr: [
        {
          name: 'hiring',
          value: Object.keys(complete_data?.hiring).join(','),
        },
        {
          name: 'project',
          value: complete_data?.project,
        },
        {
          name: 'strength',
          value: complete_data?.strength,
        },
        {
          name: 'timeing',
          value: complete_data?.timeing,
        },
      ],
      first_name: complete_data?.details?.first_name,
      last_name: complete_data?.details?.last_name,
      email: complete_data?.details?.email,
      number: complete_data?.details?.contact_number,
    }
    return params
  },[complete_data])

  const countryOptions = Object.keys(countries.countries).map((countryCode) => ({
    value: countryCode,
    label: countries.countries[countryCode].name,
  }));

  useMemo(() => {
    if (complete_data?.hiring) {
      const keysArray = Object.keys(complete_data.hiring);
      const filteredKeysArray = keysArray.filter(key => complete_data.hiring[key] !== false);
      parameters.client_requirement.data.hiring_roles = [...filteredKeysArray]
    }
    parameters.client_requirement.data.company_strength.push(complete_data.strength)
    parameters.client_requirement.data.project_type.push(complete_data.project)
    parameters.client_requirement.data.contract_duration.push(complete_data.timeing)
  }, [])

  useMemo(() => {
    if (complete_data?.details) {
      for (const key in complete_data?.details) {
        if (complete_data.details.hasOwnProperty(key)) {
          parameters.client_requirement[key] = complete_data.details[key];
        }
      }
    }
  }, [details_data])

  const handleChange = (e, name) => {
    const value = e.target.value
    setRole({ ...role, [name]: value })
    dispatch(userDetails({ ...details_data, [name]: value }))
  }
  const handlephoneChange = (value) => {
    setRole({ ...role, ["contact_number"]: value })
    dispatch(userDetails({ ...details_data, ["contact_number"]: value }))
  }
  // const handleCountryChange = (value) => {
  //   setRole({ ...role, ["country"]: value.value})
  //   dispatch(userDetails({ ...role, ["country"]: value.value }))
  // }

  const validateEmail = (_email) => {
    if (
      /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(_email) &&
      _email.length > 0
    ) {
      setEmailValid(true);
      return true;
    }
    setEmailValid(false);
    return false;
  };

  const validateNumber = (_number) => {
    if (
      /^\+?\d{7,15}$/i.test(_number) &&
      _number.length > 0
    ) {
      setNumberValid(true);
      return true;
    }
    setNumberValid(false);
    return false;
  };

  // const validateCountry = (_input) => {
  //   if (
  //     _input.length > 0
  //   ) {
  //     setCountryValid(true);
  //     return true;
  //   }
  //   setCountryValid(false);
  //   return false;
  // };

  const validatefname = (_fname) => {
    if (
      _fname.length > 0
    ) {
      setFnameValid(true);
      return true;
    }
    setFnameValid(false);
    return false;
  };

  const validatelname = (_lname) => {
    if (
      _lname.length > 0
    ) {
      setLnameValid(true);
      return true;
    }
    setLnameValid(false);
    return false;
  };

  useEffect(() => {
    if (details_data.first_name) {
      setFnameValid(true);
    }
    if (details_data.last_name) {
      setLnameValid(true);
    }
    if (details_data.email && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(details_data.email ) &&
    details_data.email.length > 0) {
      setEmailValid(true);
    }
    if (details_data.contact_number && /^\+?\d{7,15}$/i.test(details_data.contact_number ) &&
    details_data?.contact_number.length > 0) {
      setNumberValid(true);
    }
    // if (details_data.country) {
    //   setCountryValid(true);
    // }
  }, [details_data]);

  const prevButton = () => {
    navigate('/HireTalent4')
  }

  const handleSubmit = (event) => {
    setIsLoading(true)
    if (fnameValid && lnameValid && emailValid && numberValid) {
      postFormData(payload).then((res) => {
        setSubmitted(true)
        setIsLoading(false)
        navigate('/HireTalent6')
      })
        .catch((err) => {
          setIsLoading(false)
          setSubmitted(false);
        })
      
    }
    else {
      setSubmitted(false)
    }
  }

  const hire_talent_bg = {
    backgroundImage: `url(${background})`,
    height: '100vh',
    width: '100%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? '#86b7fe' : provided.borderColor,
      boxShadow: state.isFocused
        ? '0 0 0 0.25rem rgba(13, 110, 253, 0.25)'
        : provided.boxShadow,
    }),
  };

  return (
    <>
      <div className='hire_talent_wrapper'>
        <Row>
          <Col md={7} xs={12}>
            <div className="hire_talent_content">
              <Container>
                <div className="top_head text-center">
                  <img src={main_Logo} alt="Logo" />
                  <h4>Thank you for your interest in RubyPy.</h4>
                  <p>We do not yet offer top talent in India</p>
                </div>
                <Row className='card_padding'>

                  <Card.Body>
                    <Form onSubmit={handleSubmit}>
                      <Form.Control
                        required
                        type="text"
                        name="first_name"
                        isInvalid={fnameValid == null ? false : !fnameValid}
                        value={details_data?.first_name}
                        onChange={(e) => {
                          handleChange(e, e.target.name);
                          validatefname(e.target.value)
                        }}
                        style={{ margin: "3vh", width: "94%" }}
                        placeholder="First Name*"
                      />
                      <Form.Control
                        required
                        type="text"
                        name="last_name"
                        isInvalid={lnameValid == null ? false : !lnameValid}
                        onChange={(e) => {
                          handleChange(e, e.target.name);
                          validatelname(e.target.value)
                        }}
                        value={details_data?.last_name}
                        style={{ margin: "3vh", width: "94%" }}
                        placeholder="Last Name*"
                      />
                      <Form.Control
                        required
                        type="email"
                        name="email"
                        isInvalid={emailValid == null ? false : !emailValid}
                        onChange={(e) => {
                          handleChange(e, e.target.name);
                          validateEmail(e.target.value)
                        }}
                        value={details_data?.email}
                        style={{ margin: "3vh", width: "94%" }}
                        placeholder="E-mail*"
                      />
                      <PhoneInput
                        className="selectform contactcode "
                        international
                        defaultCountry="IN"
                        // countryCallingCodeEditable={false} 
                        isinvalid={numberValid == null ? false : !numberValid}
                        name="contact_number"
                        value={details_data?.contact_number}
                        onChange={(value) => {
                          handlephoneChange(value);
                          validateNumber(value)
                        }}
                        style={{ margin: "3vh", width: "94%" }}
                        placeholder="Contact number*"
                      />
                      {/* <Form.Control
                        required
                        type="text"
                        name="country"
                        isInvalid={countryValid == null ? false : !countryValid}
                        onChange={(e) => {
                          handleChange(e, e.target.name);
                          validateCountry(e.target.value)
                        }}
                        value={details_data?.country}
                        style={{ margin: "3vh", width: "94%" }}
                        placeholder="Country"
                      /> */}
                      {/* <Select
                        value={details_data?.country}
                        name="country"
                        isInvalid={countryValid == null ? false : !countryValid}
                        onChange={(countryOptions) => {
                          handleCountryChange(countryOptions);
                          validateCountry(countryOptions.value)
                        }}
                        options={countryOptions}
                        placeholder="Select a country"
                        styles={customStyles}
                      /> */}
                    </Form>
                  </Card.Body>
                  <Card.Footer className="d-flex justify-content-between ">
                    <Button onClick={prevButton}>Previous</Button>
                    <Button onClick={handleSubmit} disabled={!fnameValid || !lnameValid || !emailValid || !numberValid || isLoading}>{isLoading ? "Loading..." : "Submit"}</Button>
                  </Card.Footer>
                </Row>
              </Container>
            </div>
          </Col>
          <Col md={5} xs={12}>
            <div className="hire_talent_right_wrapper" style={hire_talent_bg}>
              <div className="hire_talent_logo">
                <div>
                  <h3>TRUSTED BY</h3>
                  <ul>
                    <li><img src={Logo} alt="fire icon" /></li>
                    <li><img src={Logo3} alt="fire icon" /></li>
                    <li><img src={Logo4} alt="fire icon" /></li>
                    <li><img src={Logo5} alt="fire icon" /></li>
                    <li><img src={Logo6} alt="fire icon" /></li>
                    <li><img src={Logo} alt="fire icon" /></li>
                    <li><img src={Logo3} alt="fire icon" /></li>
                    <li><img src={Logo4} alt="fire icon" /></li>
                  </ul>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default HireTalent5;